var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 426.337,
    className: "st0",
    width: 433.932,
    height: 46.204
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.243,76.344c-4.611-10.872-12.23-20.053-21.86-26.56c-9.613-6.507-21.368-10.332-33.794-10.325h-39.092 H390.72h-1.325H267.282v104.808l34.661,31.399c3.532,3.197,5.542,7.733,5.542,12.483v42.051c0,9.294-7.537,16.832-16.84,16.832 H225.28c-9.295,0-16.824-7.537-16.824-16.832v-42.051c0-4.75,2.011-9.286,5.527-12.483l33.499-30.328V39.459H51.166 c-7.006,0-13.791,1.43-19.922,4.03c-9.213,3.899-16.979,10.358-22.497,18.516C3.237,70.139-0.008,80.112,0,90.625v95.686 c0,28.408,5.771,55.596,16.219,80.284c15.67,37.048,41.789,68.488,74.7,90.724c32.887,22.236,72.69,35.249,115.329,35.233 c28.416,0.008,55.605-5.772,80.292-16.21c37.032-15.68,68.489-41.798,90.724-74.702c4.268-6.318,8.191-12.891,11.755-19.684 c0.556,0.008,1.128,0.057,1.701,0.057c16.676,0,32.698-3.393,47.217-9.54c21.794-9.221,40.253-24.574,53.332-43.915 c13.08-19.325,20.73-42.787,20.73-67.826c0-18.638,0-33.86,0-44.421c0-10.553,0-16.44,0-16.44 C512,91.581,510.3,83.578,507.243,76.344z M465.797,116.31c0,10.562,0,25.784,0,44.421c-0.017,10.431-2.11,20.25-5.886,29.217 c-5.69,13.447-15.238,24.957-27.238,33.058c-7.717,5.199-16.398,8.976-25.751,11.028c3.63-15.336,5.575-31.317,5.575-47.724V85.663 h39.092c2.027,0,3.842,0.392,5.526,1.104c2.518,1.063,4.741,2.894,6.262,5.166c1.537,2.297,2.403,4.904,2.42,7.93 C465.797,99.863,465.797,105.757,465.797,116.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.6227d006e46c27f924b0e943c4d001f4.svg";
export { ForwardRef as ReactComponent };